import { Box, TextField, IconButton } from "@mui/material";
import { useDispatch } from "react-redux";
import { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import Iconify from "../../../../../../reusable-components/iconify";
import { editTicketData } from "../../../../../../redux/slices/tickets";
import { useSnackbar } from "../../../../../../reusable-components/snackbar";
import { useSelector } from "../../../../../../redux/store";
import TicketSubject from "../TicketSubject";

EditTicketSubject.propTypes = {
  ticketSubject: PropTypes.string,
  setExternalTicketSubject: PropTypes.func,
  ticketNumber: PropTypes.number,
  ticketSubjectSx: PropTypes.object,
};

export default function EditTicketSubject({ ticketSubject, setExternalTicketSubject, ticketNumber, ticketSubjectSx }) {
  const { id = '' } = useParams();
  const dispatch = useDispatch();
  const [isEditingSubject, setIsEditingSubject] = useState(false);
  const subjectInputRef = useRef(null);
  const { enqueueSnackbar} = useSnackbar();
  const [subject, setSubject] = useState(ticketSubject);
  const { mainTicket } = useSelector((state) => state.tickets.data.ticketInfoById[ id] || {});

  useEffect(() => {
    if (isEditingSubject && subjectInputRef.current) subjectInputRef.current.focus();
  }, [isEditingSubject]);

  useEffect(() => {
    setSubject(ticketSubject);
  }, [ticketSubject]);

  const handleSubjectIconClick = () => {
    if (isEditingSubject) {
      setIsEditingSubject(false);
      handleEditSubject();
    }
    else {
      setIsEditingSubject(true);
    }
  }
  
  const handleEditSubject = async () => {
    try {
      if (ticketNumber) {
        const response = await dispatch(editTicketData({ Id: ticketNumber, value: subject, updateType: "ExtraInfo" }));
        if (response) {
          enqueueSnackbar(`Ticket subject updated successfully`, { variant: 'success' });
        } else {
          enqueueSnackbar('Failed to update subject', { variant: 'error' });
        }
      } else {
        setExternalTicketSubject(subject);
      }
    } catch (error) {
      enqueueSnackbar('An unexpected error occurred', { variant: 'error' });
    }
  };

  return <Box sx={{ display: 'flex', flex: 1, minWidth: 0 }}>
    {isEditingSubject ? 
      <TextField
        fullWidth
        size="small"
        variant="standard"
        defaultValue={subject}
        onChange={(e) => setSubject(e.target.value)}
        inputRef={subjectInputRef}
      /> : 
      <TicketSubject subject={subject} sx={ticketSubjectSx}/>
    }
    {(!id || mainTicket && !mainTicket.locked) && <IconButton sx={{ padding: 0 }} onClick={handleSubjectIconClick}>
      {isEditingSubject ? <Iconify color="primary" icon="mdi:check" /> : <Iconify icon="mdi:pencil" />}
    </IconButton>}
  </Box>
}